import { ChevronLeft, ChevronRight } from "lucide-react";

interface OrderPaginationProps {
  page: number;
  totalPages: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

const OrderPagination: React.FC<OrderPaginationProps> = ({
  page,
  totalPages,
  totalCount,
  onPageChange,
}) => {
  const renderPages = () => {
    const pages: (number | string)[] = [];
    const delta = 2;
    for (let i = Math.max(2, page - delta); i <= Math.min(totalPages - 1, page + delta); i++) {
      pages.push(i);
    }
    const result: (number | string)[] = [1];
    if (pages.length > 0 && (pages[0] as number) > 2) result.push("...");
    result.push(...pages);
    if (pages.length > 0 && (pages[pages.length - 1] as number) < totalPages - 1) result.push("...");
    if (totalPages > 1) result.push(totalPages);
    return result;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-4 text-sm text-slate-500">
      <span>
        Page {page} of {totalPages} · {totalCount} orders
      </span>
      <div className="flex items-center gap-1">
        <button
          className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 text-sm hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft size={16} />
        </button>
        {renderPages().map((p, i) =>
          typeof p === "string" ? (
            <span key={i} className="px-1 text-slate-400">...</span>
          ) : (
            <button
              key={i}
              className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${page === p
                ? "bg-gradient-to-br from-emerald-500 to-emerald-700 text-white border-transparent"
                : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"
                }`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          )
        )}
        <button
          className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 text-sm hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default OrderPagination;
